import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import { VueSpinners } from "@saeris/vue-spinners";
import * as VueGoogleMaps from "vue2-google-maps";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VuePivottable from "vue-pivottable";
import DatePicker from 'vue2-datepicker';
import VueFormWizard from 'vue-form-wizard'

import 'vue2-datepicker/index.css';
import "vue-pivottable/dist/vue-pivottable.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-select/dist/vue-select.css";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

import ECharts from 'vue-echarts'
import 'echarts'



Vue.config.productionTip = false;

store.dispatch("getUser");


window.Pusher = Pusher

// Configuración de Laravel Echo para Laravel Websockets local
const echoConfig = {
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY || 'local',
  wsHost: process.env.VUE_APP_WEBSOCKET_HOST || 'localhost',
  wsPort: process.env.VUE_APP_WEBSOCKET_PORT || 6001,
  wssPort: process.env.VUE_APP_WEBSOCKET_PORT || 6001,
  //forceTLS: false,
  forceTLS: true,
  encrypted: false,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
}


// Solo agregar cluster si se está usando Pusher real (no Laravel Websockets)
if (process.env.VUE_APP_PUSHER_APP_CLUSTER) {
  echoConfig.cluster = process.env.VUE_APP_PUSHER_APP_CLUSTER
} else {
  // Para Laravel Websockets local, usar un cluster por defecto para evitar el error
  echoConfig.cluster = 'mt1'
}

window.Echo = new Echo(echoConfig)

const options = {
  color: "#6c757d",
  thickness: "6px",
  autoRevert: true,
  transition: {
    speed: "0.3s",
    opacity: "0.4s",
    termination: 400,
  },
  inverse: false,
};

const optionsSwal = {
  confirmButtonColor: "#6c757d",
  cancelButtonColor: "#00529c",
};

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDorGBuQDKfQe-_r9c0eOmo4sEF5av8J50",
    libraries: ["places", "geometry"],
    v: "weekly",
  },
});

Vue.use(VueProgressBar, options);
Vue.use(VueSweetalert2, optionsSwal);
Vue.use(VueSpinners);
Vue.use(VuePivottable);
Vue.use(Vuelidate);
Vue.use(VueFormWizard)
Vue.component("v-select", vSelect);
Vue.component('date-picker', DatePicker);
Vue.component('v-chart', ECharts)

Vue.directive("only-numbers", {
  bind(el) {
    el.addEventListener("input", (e) => {
      const newValue = e.target.value.replace(/\D/g, ""); // solo números

      if (newValue !== e.target.value) {
        e.target.value = newValue;

        // notificar a Vue que el valor cambió
        const evt = new Event("input", { bubbles: true });
        e.target.dispatchEvent(evt);
      }
    });
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
